var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"inline-block"}},[_c('span',{staticClass:"Disp_AC SysFontM fs18",staticStyle:{"cursor":"pointer","height":"100%"},style:({
            color: _vm.color,
        }),on:{"click":function($event){return _vm.$emit('click')}}},[_c('cl-svg-icon',{attrs:{"width":"20","currentColor":false,"icon-class":_vm.icon}}),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }